import { ApiOrderServiceType } from "../order/order-api.service";

export enum ServiceType {
  baseToBaseDelivery = "baseToBaseDelivery",
  firstTimePickup = "firstTimePickup",
  localDelivery = "localDelivery",
  localPickup = "localPickup",
  nationwideDelivery = "nationwideDelivery",
  nationwidePickup = "nationwidePickup",
}

export const anyDeliveryType = [
  ServiceType.localDelivery,
  ServiceType.baseToBaseDelivery,
  ServiceType.nationwideDelivery,
];

export function isAnyDeliveryType(serviceType: ServiceType): boolean {
  return anyDeliveryType.includes(serviceType);
}

export const anyPickupType = [ServiceType.localPickup, ServiceType.firstTimePickup, ServiceType.nationwidePickup];

export function isAnyPickupType(serviceType: ServiceType): boolean {
  return anyPickupType.includes(serviceType);
}

export function planServiceTypeToShortLabel(serviceType: ServiceType | ApiOrderServiceType): string {
  switch (serviceType) {
    case ServiceType.localDelivery:
      return "Local delivery";
    case ServiceType.localPickup:
      return "Local pickup";
    case ServiceType.baseToBaseDelivery:
      return "Base to base";
    case ServiceType.firstTimePickup:
      return "First time";
    case ServiceType.nationwideDelivery:
      return "Nationwide Delivery";
    case ServiceType.nationwidePickup:
      return "Nationwide Pickup";
    default:
      return "";
  }
}

const legacyServiceTypeMap: Record<string, ServiceType> = {
  "Base to base delivery": ServiceType.baseToBaseDelivery,
  "First time pickup": ServiceType.firstTimePickup,
  "Local delivery": ServiceType.localDelivery,
  "Local pickup": ServiceType.localPickup,
  "Nationwide delivery": ServiceType.nationwideDelivery,
  "Nationwide pickup": ServiceType.nationwidePickup,
};

export function normalizeServiceType(serviceType: string): ServiceType {
  if (Object.values(ServiceType).includes(serviceType as ServiceType)) {
    return serviceType as ServiceType;
  }
  const mapped = legacyServiceTypeMap[serviceType];
  if (mapped) {
    return mapped;
  }
  throw new Error(`Unknown serviceType: ${serviceType}`);
}
